module.exports = __webpack_public_path__ + "media/images/iconArrowUp-95876e134c0b7bb9f218bdae151ffb60.png";